/* Thurgo: scroll reveals, stat counters, callback form states. No dependencies. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveals: content is visible without JS; .th-js hides it until it enters.
  const revealed = document.querySelectorAll('[data-reveal]');
  if (reduce || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
    revealed.forEach((el) => el.classList.add('is-in'));
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    revealed.forEach((el) => io.observe(el));
  }

  // Stat counters: "£84,000+" counts up from 0, keeping its prefix, separators and suffix.
  const counters = document.querySelectorAll('[data-count]');
  const run = (el) => {
    const match = el._count;
    if (!match) return;
    const [, pre, digits, post] = match;
    const target = Number(digits.replace(/,/g, ''));
    const comma = digits.includes(',');
    const start = performance.now();
    const dur = 1400;
    const step = (now) => {
      const t = Math.min(1, (now - start) / dur);
      const v = Math.round(target * (1 - Math.pow(1 - t, 4)));
      el.textContent = pre + (comma ? v.toLocaleString('en-GB') : v) + post;
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  if (!reduce && 'IntersectionObserver' in window) {
    const co = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          run(e.target);
          co.unobserve(e.target);
        }
      },
      { threshold: 0.6 }
    );
    counters.forEach((el) => {
      // start from zero so the final figure never flashes before counting
      el._count = el.textContent.trim().match(/^(\D*)([\d,]+)(.*)$/);
      if (el._count) el.textContent = el._count[1] + '0' + el._count[3];
      co.observe(el);
    });
  }

  // Callback form: inline validation, busy state on submit.
  document.querySelectorAll('form[data-th-form]').forEach((form) => {
    const msg = (field) => {
      if (field.validity.valueMissing) return field.dataset.missing || 'Please fill this in.';
      if (field.validity.typeMismatch) return field.dataset.invalid || 'Please check this.';
      return '';
    };
    const show = (field) => {
      const err = form.querySelector(`#${field.id}-error`);
      const text = msg(field);
      field.setAttribute('aria-invalid', text ? 'true' : 'false');
      if (err) err.textContent = text;
      return !text;
    };
    form.noValidate = true;
    form.querySelectorAll('input[required], input[type="email"]').forEach((field) => {
      field.addEventListener('blur', () => field.value && show(field));
      field.addEventListener('input', () => field.getAttribute('aria-invalid') === 'true' && show(field));
    });
    form.addEventListener('submit', (event) => {
      const fields = [...form.querySelectorAll('input[required], input[type="email"]')];
      const bad = fields.filter((f) => !show(f));
      if (bad.length) {
        event.preventDefault();
        bad[0].focus();
        return;
      }
      const btn = form.querySelector('button[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
    });
  });

  // Trustpilot TrustBox: load the official script only when a widget is on the page and near view.
  const box = document.querySelector('.trustpilot-widget');
  if (box) {
    const load = () => {
      const s = document.createElement('script');
      s.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      s.async = true;
      document.head.append(s);
    };
    if ('IntersectionObserver' in window) {
      const to = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          to.disconnect();
          load();
        }
      }, { rootMargin: '400px' });
      to.observe(box);
    } else load();
  }
})();
